import { useState, useEffect } from 'react';
import { History, ChevronDown, ChevronUp, FileSpreadsheet } from 'lucide-react';
import api from '@/lib/api';
import { fmtDate } from '@/lib/utils';

export default function UploadHistory({ refreshKey }) {
  const [uploads, setUploads] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get('/uploads').then(({ data }) => setUploads(data)).catch(() => {});
  }, [refreshKey]);

  if (!uploads.length) return null;

  return (
    <div className="border border-zinc-200 bg-white">
      <button
        data-testid="upload-history-toggle"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-2.5 text-left hover:bg-zinc-50 transition-colors"
      >
        <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.08em] uppercase text-zinc-500">
          <History className="h-3.5 w-3.5" /> Upload History
          <span className="bg-zinc-100 text-zinc-500 border border-zinc-200 px-1.5 py-0 text-[10px] font-bold normal-case tracking-normal">{uploads.length}</span>
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-zinc-400" /> : <ChevronDown className="h-4 w-4 text-zinc-400" />}
      </button>
      {open && (
        <div data-testid="upload-history-list" className="border-t border-zinc-200 divide-y divide-zinc-100 max-h-[280px] overflow-y-auto">
          {uploads.map((u) => (
            <div key={u.id} className="flex items-center gap-3 px-4 py-2 text-xs">
              <FileSpreadsheet className="h-3.5 w-3.5 text-zinc-300 shrink-0" />
              <span className="font-medium text-zinc-700 truncate flex-1" title={u.filename}>{u.filename}</span>
              <span className={`px-1.5 py-0 text-[9px] font-bold uppercase tracking-wider border shrink-0 ${
                u.upload_type === 'purchase'
                  ? 'bg-sky-50 text-sky-700 border-sky-200'
                  : 'bg-emerald-50 text-emerald-700 border-emerald-200'
              }`}>
                {u.upload_type === 'purchase' ? 'Purchase' : 'Sales'}
              </span>
              <span className="font-mono text-zinc-500 shrink-0">{u.cleaned_rows} rows</span>
              {u.flagged_rows > 0 && <span className="font-mono text-amber-600 shrink-0">{u.flagged_rows} flagged</span>}
              <span className="text-zinc-400 shrink-0 hidden sm:block">{fmtDate(u.uploaded_at, true)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
